import { useQuery } from '@tanstack/react-query';
import { getPointService } from '../../../domains/point';

const isResultOk = (res: any) => res?.result_code === '200' || res?.resultCode === 200;

/** 팜포인트 KPI — GET /point/kpi/{brn}?month=YYYY-MM (v2 H-1). 약국 토큰 필수 */
export const usePointKpi = (brn: string | null | undefined, month: string) =>
  useQuery({
    queryKey: ['point-kpi', brn, month],
    enabled: !!brn,
    queryFn: async () => {
      const res = await getPointService().getPointKpi(brn, { month });
      if (!isResultOk(res)) throw new Error(res?.result_msg || '포인트 KPI 조회 실패');
      return res.data as Record<string, any>;
    },
  });

/** 팜포인트 기간별 현황 — GET /point/stats/{brn} (v2 H-2). items 는 오래된 구간부터 */
export const usePointStats = (
  brn: string | null | undefined,
  params: { unit: string; start_date: string; end_date: string }
) =>
  useQuery({
    queryKey: ['point-stats', brn, params],
    enabled: !!brn,
    queryFn: async () => {
      const res = await getPointService().getPointStats(brn, params);
      if (!isResultOk(res)) throw new Error(res?.result_msg || '포인트 기간별 현황 조회 실패');
      return (res?.data?.items ?? []) as any[];
    },
  });
